export type SpanConflictSide = "visual" | "audio";

export interface SpanConflictDialogProps {
  side: SpanConflictSide;
  previews: string[];
  onMerge: () => void;
  onClear: () => void;
  onCancel: () => void;
}

/** Ask how to handle text that would be covered by extending a row span. */
export function SpanConflictDialog({
  side,
  previews,
  onMerge,
  onClear,
  onCancel,
}: SpanConflictDialogProps) {
  const isVisual = side === "visual";
  const title = isVisual ? "Billedtekst i vejen" : "Lydtekst i vejen";
  const noun = isVisual ? "billedside-tekst" : "lydside-tekst";
  const dragTarget = isVisual ? "billedet" : "lyden";
  const mergeLabel = isVisual
    ? "Flyt teksten op i billedet"
    : "Flyt teksten op i lyden";

  return (
    <div className="sm-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="sm-dialog"
        role="alertdialog"
        aria-labelledby="sm-span-conflict-title"
        aria-describedby="sm-span-conflict-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="sm-span-conflict-title">{title}</h2>
        <p id="sm-span-conflict-desc">
          Du trækker {dragTarget} ned over{" "}
          {previews.length === 1 ? "en række" : `${previews.length} rækker`} der
          allerede har {noun}. Hvad vil du gøre?
        </p>
        <ul className="sm-dialog-previews">
          {previews.map((text, i) => (
            <li key={i}>
              <pre>{text}</pre>
            </li>
          ))}
        </ul>
        <div className="sm-dialog-actions">
          <button type="button" onClick={onCancel}>
            Annuller
          </button>
          <button type="button" onClick={onClear}>
            Ryd den dækkede tekst
          </button>
          <button type="button" className="sm-dialog-primary" onClick={onMerge}>
            {mergeLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

/** @deprecated Prefer SpanConflictDialog with side="visual" */
export function VisualSpanConflictDialog(
  props: Omit<SpanConflictDialogProps, "side">,
) {
  return <SpanConflictDialog {...props} side="visual" />;
}
